/* eslint-disable react/require-default-props */
import PropTypes from 'prop-types'
import React from 'react'
import DOMPurify from 'dompurify'

import './styles.css'

class TutorialMaterials extends React.Component {
  constructor(props) {
    super(props)
    this.state = { showFullMaterials: false }

    this.toggleFullMaterials = this.toggleFullMaterials.bind(this)
  }

  toggleFullMaterials() {
    this.setState({ showFullMaterials: !this.state.showFullMaterials })
  }

  render() {
    return (
      <div className="TutorialMaterials">
        <div className="TutorialMaterials__content--expanded">
          <div
            className="formatted"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.materials) }}
          />
          {this.props.referenceMaterials && (
            <div
              className="formatted"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(this.props.referenceMaterials) }}
            />
          )}
        </div>
      </div>
    )
  }
}

TutorialMaterials.propTypes = {
  materials: PropTypes.string.isRequired,
  referenceMaterials: PropTypes.string
}

TutorialMaterials.defaultProps = {
  referenceMaterials: ''
}

export default TutorialMaterials
